/* global axios */
import ApiClient from '../ApiClient';

// Two provider operations behind one client: an agent holding a reference does not
// always know whether it is a booking or a ticket, so the screen offers both and this
// picks the endpoint.
class TravelBookings extends ApiClient {
  constructor() {
    super('travel', { accountScoped: true });
  }

  retrieveReservation(locator) {
    return axios.get(`${this.url}/reservations/${encodeURIComponent(locator)}`);
  }

  retrieveTicket(ticketNumber) {
    return axios.get(`${this.url}/tickets/${encodeURIComponent(ticketNumber)}`);
  }

  // Creates the hosted itinerary and returns its link. The URL comes back once and is
  // never re-readable - only its digest is stored - so whatever calls this has to keep
  // what it is handed.
  createDocument({ recordLocator, contactId, conversationId }) {
    return axios.post(`${this.url}/documents`, {
      record_locator: recordLocator,
      contact_id: contactId,
      conversation_id: conversationId,
    });
  }
}

export default new TravelBookings();
